// Feature flag utility
const feature = (enabled = false, required = false) => ({ enabled, required });

const ENABLED = feature(true, false);

const DISABLED = feature(false, false);

// All features are enabled by default
const defaultActionConfigFeatures = {
  social_publish: ENABLED,
  chapters: ENABLED,
  transcript: ENABLED,
  logs: ENABLED,
  subtitles: ENABLED,
  restrictions: ENABLED,
  embed: ENABLED,
  create_simulive: ENABLED,
  create_clone: ENABLED,
  duplicate: ENABLED,
  clips_from_chapters: ENABLED,
  download: ENABLED,
  archive: ENABLED,
  delete: ENABLED,
  podcast: ENABLED,
};

const withOverrides = (
  overrides: Partial<typeof defaultActionConfigFeatures>
): typeof defaultActionConfigFeatures => ({
  ...defaultActionConfigFeatures,
  ...overrides,
});

// Map based on your matrix — only override where explicitly disabled
const actionConfigFeatureMap = {
  media: withOverrides({
    duplicate: DISABLED,
  }), // all enabled by default
  drive: withOverrides({
    subtitles: DISABLED,
    chapters: DISABLED,
  }),
  embed: withOverrides({
    social_publish: DISABLED,
    chapters: DISABLED,
    subtitles: DISABLED,
    create_simulive: DISABLED,
    create_clone: DISABLED,
  }),
  simulive: withOverrides({
    social_publish: DISABLED,
    chapters: DISABLED,
    transcript: DISABLED,
    subtitles: DISABLED,
    create_simulive: DISABLED,
    create_clone: DISABLED,
  }),
  clone: withOverrides({
    create_clone: DISABLED,
  }),
  chapter: withOverrides({
    // duplicate: DISABLED,
    create_clone: DISABLED,
  }),
  video: withOverrides({
    create_clone: DISABLED,
  }),
  podcast: withOverrides({
    create_clone: DISABLED,
    create_simulive: DISABLED,
    duplicate: DISABLED,
  }),
  slates: withOverrides({
    create_clone: DISABLED,
    create_simulive: DISABLED,
    duplicate: DISABLED,
    podcast: DISABLED,
  }),
  campaign: withOverrides({
    create_clone: DISABLED,
    create_simulive: DISABLED,
    duplicate: DISABLED,
    podcast: DISABLED,
  }),
  shorts: withOverrides({
    create_clone: DISABLED,
  }),
  premiere: withOverrides({
    social_publish: DISABLED,
    create_simulive: DISABLED,
    create_clone: DISABLED,
  }),
} as const;

export type ActionConfigFeatureMapKey = keyof typeof actionConfigFeatureMap;
export type ActionConfigFeatures = typeof defaultActionConfigFeatures;

export const getActionConfigFeatures = (
  type: ActionConfigFeatureMapKey
): ActionConfigFeatures => {
  return actionConfigFeatureMap[type] ?? defaultActionConfigFeatures;
};
